import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useCreateServer } from '../../hooks/useServers';
import { ServerForm, ServerFormData } from '../../components/server/ServerForm';
import { Card, CardHeader, CardTitle, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { useToastStore } from '../../stores/toastStore';
import { getErrorMessage } from '../../lib/api/client';

export function NewServerPage() {
  const navigate = useNavigate();
  const createServer = useCreateServer();
  const { addToast } = useToastStore();

  const handleSubmit = async (data: ServerFormData) => {
    try {
      await createServer.mutateAsync(data);
      addToast({ type: 'success', message: 'Server created successfully' });
      navigate('/servers');
    } catch (error: unknown) {
      addToast({ type: 'error', message: getErrorMessage(error) });
    }
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => navigate('/servers')}
        className="gap-2"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Servers
      </Button>

      <Card>
        <CardHeader>
          <CardTitle>Add New Server</CardTitle>
        </CardHeader>
        <CardContent>
          <ServerForm
            onSubmit={handleSubmit}
            onCancel={() => navigate('/servers')}
            isLoading={createServer.isPending}
          />
        </CardContent>
      </Card>
    </div>
  );
}
